import type { BlockAbstract, PageMode } from '@lighthouse/core'

/** 右侧栏类型 */
export enum AsideType {
    'BLOCK',
    'PAGE',
    'NAVBAR'
}

export type NodeIdWithScope = {
    scope?: string
    id: string
}

/** 页面内部状态 */
export type PageInternalState = {
    asideType: AsideType
    /** 选中的node */
    selectedNodes?: NodeIdWithScope[]
}

export type FetchBlocksAtomPayload = {
    pageId: string
    stackId: string
}

/** 移动页面参数类型 */
export type MovePagePayload = {
    id: string
    oldId?: string
    newId?: string
    position: 'prev' | 'current' | 'next'
}

/** 创建页面block参数类型 */
export type CreateBlockAtomPayload = {
    blocks: BlockAbstract[]
    createdBlocks: BlockAbstract[]
    pageId: string
    stackId: string
    autoSelect?: boolean
    scope?: string
    skipInspection?: boolean
}

/** 发送请求更新block的参数类型 */
export type UpdateBlockAtomPayload = FetchBlocksAtomPayload & {
    appId: string
    block: BlockAbstract
    origin: BlockAbstract
    blocks?: BlockAbstract[]
}
export type UpdateLocalBlockAtom = {
    pageId: string
    block: BlockAbstract
}

/** 移除页面block参数类型 */
export type RemoveBlockAtomPayload = {
    stackId: string
    blocks: BlockAbstract[]
    removedBlocks: BlockAbstract[]
    pageId: string
    clearSelected?: boolean
}

export type CreatePagePayload = {
    name?: string
    lang?: string
    groupId?: string
    type: PageMode
}

export interface ContainerDesignState {
    paddingLeft: boolean | undefined
    paddingTop: boolean | undefined
    paddingRight: boolean | undefined
    paddingBottom: boolean | undefined
    gap: boolean | undefined
}
